import { TranslatePipe } from '@ngx-translate/core';
import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';

import { ProductInfoService } from 'libs/product/src/lib/services';
import { TreatmentModel } from 'libs/treatments/src/lib/models/treatment.model';

@Component({
    selector: 'lib-shipping-insert-print-overlay',
    templateUrl: './shipping-insert-print-overlay.component.html',
    styleUrls: ['./shipping-insert-print-overlay.component.scss'],
    imports: [MatButton, MatDialogClose, TranslatePipe]
})

export class ShippingInsertPrintOverlayComponent{
	private productInfoService = inject(ProductInfoService);

	data = inject<{
		treatment: TreatmentModel;
		customer: {
			displayName: string;
			wmsId: string;
		};
	}>(MAT_DIALOG_DATA);


	print() {
		window.print();
	}

	protected getProductNameHtml(): string {
		return this.productInfoService.getProductNameHtml(
			this.data.treatment.product.key,
			" "
		);
	}
}
